import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";

interface getProps {
  communityId: string;
  module: string;
  isCommunityQuery?: boolean;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyCategories = async (communityId: string, module: string, isCommunityQuery = false) =>
  isCommunityQuery ? await axiosAuth.get(`v1/${module}?communityId=${communityId}`) : await axiosAuth.get(`v1/${module}/community/${communityId}`);

const useGetPropertyCategories = ({
  communityId,
  module,
  isCommunityQuery,
  queryParams
}: getProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: [module],
    queryFn: () => getPropertyCategories(communityId, module, isCommunityQuery),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyCategories;
